'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _ChangePasswordFormValidation = require('./ChangePasswordFormValidation');

var _ChangePasswordFormValidation2 = _interopRequireDefault(_ChangePasswordFormValidation);

var _account = require('redux/modules/account');

var _formComponents = require('components/formComponents');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ChangePasswordForm.scss');

var ChangePasswordForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    updatePasswordLoading: state.account.updatePasswordLoading
  };
}, { updatePassword: _account.updatePassword }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'changePasswordForm',
  propNamespace: 'changePasswordForm',
  validate: _ChangePasswordFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ChangePasswordForm, _Component);

  function ChangePasswordForm() {
    (0, _classCallCheck3.default)(this, ChangePasswordForm);
    return (0, _possibleConstructorReturn3.default)(this, (ChangePasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ChangePasswordForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChangePasswordForm, [{
    key: 'getPasswordRulesElement',
    value: function getPasswordRulesElement() {
      var t = this.props.t;

      var passwordRules = [t('No obvious password'), t('One lowercase character'), t('One uppercase character'), t('One number'), t('One special character'), t('Eight characters minimum')];
      // eslint-disable-next-line react/no-array-index-key
      return passwordRules.map(function (rule, key) {
        return _react2.default.createElement(
          'li',
          { className: styles.passwordRule, key: key },
          rule
        );
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(formData) {
      var newPassword = formData.newPassword,
          currentPassword = formData.currentPassword;

      if (!newPassword) {
        return false;
      }

      var _props = this.props,
          t = _props.t,
          reset = _props.changePasswordForm.reset;

      var promise = this.props.updatePassword(newPassword, currentPassword).promise;
      promise.then(function () {
        _toastr2.default.info(t('Password has been successfully updated'));
        reset();
      });
      return promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$changePasswor = _props2.changePasswordForm,
          handleSubmit = _props2$changePasswor.handleSubmit,
          submitting = _props2$changePasswor.submitting,
          t = _props2.t,
          updatePasswordLoading = _props2.updatePasswordLoading;


      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.changePassword) },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-35 col-sm-30 col-md-25 col-lg-20' },
            _react2.default.createElement(_reduxForm.Field, {
              type: 'password',
              name: 'currentPassword',
              component: _formComponents.formSimpleTextInput,
              placeholder: t('Enter current password'),
              hideLabel: true
            }),
            _react2.default.createElement(_reduxForm.Field, {
              type: 'password',
              name: 'newPassword',
              component: _formComponents.formSimpleTextInput,
              placeholder: t('Enter new password'),
              hideLabel: true
            }),
            _react2.default.createElement(_reduxForm.Field, {
              type: 'password',
              name: 'passwordConfirm',
              component: _formComponents.formSimpleTextInput,
              placeholder: t('Confirm new password'),
              hideLabel: true
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-25 col-sm-30 col-md-35 col-lg-40' },
            _react2.default.createElement(
              'ul',
              { className: styles.passwordRules },
              this.getPasswordRulesElement()
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-right margin-top-20' },
          updatePasswordLoading && _react2.default.createElement(_components.Loader, null),
          _react2.default.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary', disabled: submitting },
            t('Change password')
          )
        )
      );
    }
  }]);
  return ChangePasswordForm;
}(_react.Component), _class3.propTypes = {
  changePasswordForm: _propTypes2.default.object,
  t: _propTypes2.default.func,
  updatePassword: _propTypes2.default.func,
  updatePasswordLoading: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'changePassword', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePassword'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ChangePasswordForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePasswordForm/ChangePasswordForm.js
// module id = 1962
// module chunks = 1